import type { Meta, StoryObj } from "@storybook/react-vite"

import { LandingLayout } from "@/components/layouts/landing-layout"

import LandingIndexPage from "./index"
import { createPageStory } from "../storybook-helpers"

const meta = {
  title: "Pages/Landing",
  tags: ["autodocs"],
  parameters: {
    layout: "fullscreen",
  },
} satisfies Meta

export default meta

type Story = StoryObj<typeof meta>

export const Index: Story = createPageStory(LandingIndexPage, {
  name: "index",
  url: "/",
  componentProps: {
    links: {
      staffRegistration: "/staff/registration/new",
      staffSignIn: "/staff/session/new",
      userSignIn: "/session/new",
      directory: "/search",
    },
  },
  pageProps: {},
  wrap: (page) => <LandingLayout>{page}</LandingLayout>,
})
